import { FC, useState } from 'react';
import { RadioButton } from '../../components/radio-button/radio-button';
import { useLang } from '../../hooks/use-lang';
import { SchedulerSpecs } from './scheduler-specs/scheduler-specs';
import { SchedulerWeek } from './scheduler-week/scheduler-week';
import s from './scheduler.module.css';
import { SchedulerInterface } from './types';

type PeriodType = 'specific_day' | 'days_of_week' | 'everyday';
const types: PeriodType[] = ['specific_day', 'days_of_week', 'everyday'];

const typeLabel: Record<PeriodType, string> = {
  specific_day: 'Выбрать дату',
  days_of_week: 'Выбрать периодичность',
  everyday: 'Каждый день',
};

export const Scheduler: FC<Partial<SchedulerInterface>> = (props) => {
  const { t } = useLang();
  const [selectedType, setSelectedType] = useState<PeriodType>('days_of_week');

  return (
    <div className={s.feature}>
      <div className={s.controls}>
        <ul className={s.list}>
          {types.map((type) => (
            <RadioButton
              key={type}
              label={t(typeLabel[type])}
              checked={type === selectedType}
              onClick={() => {
                setSelectedType(type);

                if (type === 'specific_day') {
                  props.handleUpdateSpecs?.(props.start_date || ['']);
                }

                if (type === 'days_of_week') {
                  props.handleUpdateWeek?.(props.days_of_week || Array.from({ length: 7 }, () => false));
                }

                if (type === 'everyday') {
                  props.handleUpdateWeek?.(Array.from({ length: 7 }, () => true));
                }
              }}
            />
          ))}
        </ul>
      </div>

      {selectedType === 'days_of_week' && <SchedulerWeek {...props} />}

      {selectedType === 'specific_day' && <SchedulerSpecs {...props} />}
    </div>
  );
};
